import { useState } from "react";
import igreenIcon from '../../../statics/img/icons/igreenicon.svg'
import { IoIosArrowDown } from 'react-icons/io'
export default function ChooseAnotherWinner({ setIsOpen }: any) {
  const [isOpenSelect, setIsOpenSelect] = useState(false)
  const [selected, setSelected] = useState('Value')

  const changeSelectValue = (value: any) => {
    setSelected(value)
    setIsOpenSelect(false)
  }
  return (<>
    <div className="c-winner-reason">
      <div className="text">
        <img src={igreenIcon} alt="" />
        <h1>Please enter the reason why you choose another winner</h1>
      </div>
      <div className="select">
        <div className="defaultValue" onClick={() => setIsOpenSelect(!isOpenSelect)}>
          <p>{selected}</p>
          <IoIosArrowDown />
        </div>
        <div className={`options ${isOpenSelect && 'openSelect'}`}>
          <div className="option" onClick={() => changeSelectValue('gura')}>
            <p>gura</p>
          </div>
          <div className="option" onClick={() => changeSelectValue('gura')}>
            <p>gura</p>
          </div>
          <div className="option" onClick={() => changeSelectValue('gura')}>
            <p>gura</p>
          </div>
          <div className="option" onClick={() => changeSelectValue('gura')}>
            <p>gura</p>
          </div>
          <div className="option" onClick={() => changeSelectValue('Other')}>
            <p>Other</p>
          </div>
        </div>
      </div>
      {selected === 'Other' && <div className="c-winner-reason-textarea">
        <textarea name="" id=""></textarea>
      </div>}
      <div className="buttons">
        <button className='buttonwinner buttonOrangeWinner inverted' onClick={() => setIsOpen(false)}>Cancel</button>
        <button className='buttonwinner buttonBlueWinner'>Save</button>
      </div>
    </div>
  </>)
}